var map = {
	"./PC-MVC-TechBlog.jpg": 13,
	"./Tic-Tac-Code.jpg": 14,
	"./deep-thoughts.jpg": 15,
	"./pc-BudgetTracker.jpg": 16,
	"./silver-giggle.jpg": 17,
	"./zookeeper.jpg": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;